<template>
  <dynamic-object-form-structure
    :object-uuid="objectUUID"
    :object-layer="objectLayer"
    :loading-structure="loadingStructure"
    :loading-save="loadingSave"
    :permission-name="form.permission"
    :object-type-translation-key="form.name_translation"
    :tabs="visibleTabs"
    :active-tab="activeTab"
    :saveIsDisabled="!required.filled"
    :action-type="actionType"
    :map-element="$parent.$refs.formsContainer"
    :previous-pos-x="previousPosX"
    :previous-pos-y="previousPosY"
    :data-was-changed="dataWasChanged"
    :fields-still-need-filled="required.stillNeedFilled"
    @updateActiveTab="activeTab = $event"
    @changeViewMode="changeViewModeOfObject"
    @openDetails="openDetails"
    @refresh="refresh"
    @clearData="clearData"
    @save="saveObject"
    @close="closeForm"
    :object-data="objectData"
  >
    <template v-slot:formFields>
      <div
        v-show="visibleTabs[activeTab].type === 'photos'"
        class="form tab-content"
      >
        <forms-photo-section
          :disabled="readOnly"
          :imagesList="imagesList"
          :previous-images="previousImages"
          @updatePhoto="updatePhoto($event)"
          @removePhoto="addToPhotosToRemove($event)"
        />
      </div>

      <accessories-and-others-tab
        v-show="visibleTabs[activeTab].label === 'Accessories'"
        :accessories-selected="accessoriesSelected"
        :accessories-selected-by-material-id="accessoriesSelectedByMaterialId"
        relation-family-id-select="ts"
        family-id="ac"
        :disabled="readOnly"
      />
      <accessories-and-others-tab
        v-show="visibleTabs[activeTab].label === 'Others'"
        :accessories-selected="othersSelected"
        :accessories-selected-by-material-id="othersSelectedByMaterialId"
        relation-family-id-select="ts"
        family-id="ot"
        :disabled="readOnly"
      />

      <custom-fields-tab
        v-if="visibleTabs[activeTab].code === 'custom_fields'"
        :customFields="customFields.custom_fields"
        :objectData="objectData.custom_fields"
        :actionType="actionType"
        :disabled="readOnly"
        @updateValue="setValueInObject"
        :requiredFilled="required.filled"
      />
      <div
        v-show="visibleTabs[activeTab].type === 'form'"
        class="form tab-content"
      >
        <template v-for="field in visibleTabs[activeTab].fields">
          <input-field
            v-if="field.var_name === 'ts_material_id'"
            :key="visibleTabs[activeTab].code + field.label + field.order"
            ref="formInputField"
            :value="getValueInObject(field.var_name, field.input_type)"
            :label="field.label_client ? field.label_client : field.label"
            :variable-name="field.var_name"
            inputType="other"
            :size="field.size"
            :required="field.required"
            :required-filled="required.filled"
            :hide="field.hide"
            :fieldDisabled="field.disable"
            :tabDisabled="!userCanEditTabContent(visibleTabs[activeTab])"
            :formDisabled="readOnly"
          >
            <treeselect
              :value="getValueInObject(field.var_name, field.input_type)"
              @input="
                setValueInObject(field.var_name, $event, field.input_type)
              "
              :options="materialOptions"
              :load-options="loadMaterialOptions"
              :normalizer="materialOptionsNormalizer"
              :disabled="
                readOnly ||
                  !userCanEditTabContent(visibleTabs[activeTab]) ||
                  field.disable
              "
              class="form-input-select"
              disableFuzzyMatching
            />
          </input-field>
          <input-field
            v-else
            :key="visibleTabs[activeTab].code + field.label + field.order"
            ref="formInputField"
            :value="getValueInObject(field.var_name, field.input_type)"
            @input="setValueInObject(field.var_name, $event, field.input_type)"
            :label="field.label_client ? field.label_client : field.label"
            :variable-name="field.var_name"
            :inputType="field.input_type"
            :size="field.size"
            :required="field.required"
            :required-filled="required.filled"
            :selectOptions="field.select_list_name"
            :radioOptions="field.radio_options"
            :fieldDisabled="field.disable"
            :tabDisabled="!userCanEditTabContent(visibleTabs[activeTab])"
            :formDisabled="readOnly"
            :hide="field.hide"
            :automatic-label="field.has_automatic_label"
            :checkboxOptions="field.checkbox_options"
            :object-data="objectData"
            :labelIsLocked="objectData.ts_label_locked"
            :user-can-unlock-label="!userHasFibercloudPermission(form.permission + '_manage_label')"
            @toggle-label-lock="changeLabelMode"
            @updateCheckboxValue="updateCheckboxValue($event)"
            @removePhoto="addToPhotosToRemove($event)"
          />
        </template>
      </div>
    </template>

    <template v-slot:dialogBox>
      <app-dialog-box
        :open="dialog"
        :isPersistent="true"
        :title="$t('TechnicalSiteDialog.createTechnicalLocalTitle')"
        :content="$t('TechnicalSiteDialog.createTechnicalLocalText')"
        :main-action-label="$t('Yes')"
        @mainAction="createTechnicalLocal('Primary Node')"
        :secondary-action-label="$t('No')"
        @secondaryAction="closeDialog"
      />
    </template>
  </dynamic-object-form-structure>
</template>

<script>
import { dynamicObjectFormsMixin } from "@/mixins/forms/dynamicObjectForms/dynamicObjectFormsMixin";
import InputField from "../_Molecules/InputField";
import FormsPhotoSection from "../_SpecialTabs/Photos/PhotosForm";
import DynamicObjectFormStructure from "../_Templates/DynamicObjectFormStructure";
import AppDialogBox from "../../../_Molecules/AppDialogBox";
import { bus } from "@/main";
import { mapActions } from "vuex";
import CustomFieldsTab from "@/components/Home/Forms/_SpecialTabs/CustomFields/CustomFieldsTab.vue";
import AccessoriesAndOthersTab from "@/components/Home/Forms/_SpecialTabs/AccessoriesAndOthers/AccessoriesAndOthersTab";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";

export default {
  name: "PrimaryNodeForm",

  components: {
    AccessoriesAndOthersTab,
    AppDialogBox,
    DynamicObjectFormStructure,
    FormsPhotoSection,
    InputField,
    CustomFieldsTab
  },

  mixins: [dynamicObjectFormsMixin,checkPermissionsMixin],

  props: {
    linkObjectToPathway: {
      type: Object
    }
  },

  data() {
    return {
      technicalSiteData: {},

      dialog: false
    };
  },

  computed: {
    /**
     * Material request query parameters
     * @returns {{ts_logical_type: string, material_family_id: string}}
     */
    materialRequestQueryParameters() {
      let queryParameters = {
        material_family_id: "ts",
        ts_logical_type: "FDC"
      };

      if (this.objectData.ts_physical_type) {
        queryParameters.physical_type = this.objectData.ts_physical_type;
      }
      return queryParameters;
    }
  },

  watch: {
    /**
     * Whenever the ts_material_id changes, the updateMaterialDependentFields method is called.
     * @param newID
     */
    "objectData.ts_material_id"(newID) {
      this.updateMaterialDependentFields(newID);
    },

    /**
     * Whenever the ts_physical_type changes the materialOptions variable is null.
     * To be asked again to pick up the materials because of the filters
     */
    "this.objectData.ts_physical_type"() {
      this.materialOptions = null;
    },
    /**
     * watches material options variable, if there are values in the get request, acessories get updated.
     *
     */
    materialOptions() {
      if (this.materialOptions && this.objectData.ts_material_id) {
        this.updateMaterialDependentFields(this.objectData.ts_material_id);
      }
    }
  },

  methods: {
    ...mapActions(["CREATE_OBJECTS"]),

    createObject() {
      this.createDataToSend();

      this.CREATE_OBJECTS({
        endpoint: this.form.endpoint,
        data: [this.dataToSend]
      })
        .then(resp => {
          if (this.linkObjectToPathway.split) {
            bus.$emit("reset-pathway-and-split-data");
          }

          this.technicalSiteData = resp.data.data[0];
          this.dialog = true;
          this.updateObjectLocalStorageData();
          this.$toasted.global.toast_success(this.$i18n.t("CreationSuccess"));
        })
        .catch(error => {
          this.$toasted.global.toast_error(error.response.data.data);
        })
        .then(() => {
          this.loadingSave = false;
        });
    },

    /**
     * Prepares the data to send the server to create object
     */
    createDataToSend() {
      this.objectData.ts_logical_type = "FDC";
      this.dataToSend = {
        node: { text_geom: this.wkt, projection: 3857 },
        logical_type: this.objectData.ts_logical_type,
        status: this.objectData.ts_status,
        progress: this.objectData.ts_progress
      };

      if (this.linkObjectToPathway.split) {
        this.dataToSend.node.delete_pathways_association = "false";
        this.dataToSend.node.pathway = this.linkObjectToPathway.pathway;
      }

      if (this.accessoriesSelected || this.othersSelected) {
        this.dataToSend.accessories = [];
        this.generateAccessoriesDataSend(this.accessoriesSelected);
        this.generateAccessoriesDataSend(this.othersSelected);
      }

      this.placeObjectDataInDataToSend();
    },

    /**
     * Updates material dependent fields
     * @param materialID
     */
    updateMaterialDependentFields(materialID) {
      this.accessoriesSelectedByMaterialId = [];
      this.othersSelectedByMaterialId = [];
      if (materialID && this.materialOptions) {
        let materialOption = this.materialOptions.find(
          material => material.sm_id === materialID
        );
        if (materialOption) {
          this.getStockMaterial(materialOption)
            .then(material => {
              if (material.family_specific_fields.smts_physical_type) {
                this.setValueInObject(
                  "ts_physical_type",
                  material.family_specific_fields.smts_physical_type
                );
              }
              if (material.others) {
                this.generateAccessoriesAndOthersSelected(
                  this.accessoriesSelectedByMaterialId,
                  this.othersSelectedByMaterialId,
                  material.others
                );
              }
            })
            .catch(error => {
              console.error(error);
            });
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/ObjectForms/PNForm.vue